import LocationsList from "./components/LocationsList";

const Locations = (response) => {

    return (
        <div>
            <LocationsList/>
        </div>
    )
}
export default Locations;